import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useCrudSelection, resetCrudSelection } from '@/atoms'
import { fitMapToSelection } from '@/map'
import { selectUsersListStructure } from '@/features/domain/lists'
import { useSettingsEditing } from '../../../../../../../../hooks/useSettingsEditing'

export function useTitle() {
  const listStructure = useSelector(selectUsersListStructure)
  const { editing } = useSettingsEditing('user-management', 'none')

  const [selection, select] = useCrudSelection('users')

  const onSelectAll = useCallback(() => {
    const allSelected = listStructure.shownItems <= selection.length

    if (allSelected) {
      resetCrudSelection('users')
    } else {
      select(
        listStructure.list.reduce<string[]>((acc, item) => {
          if (typeof item === 'string') {
            acc.push(item)
          }
          return acc
        }, []),
      )

      fitMapToSelection({ preventIfVisible: true }, 'add')
    }
  }, [select, selection, listStructure])

  return {
    editing,
    selection,
    onSelectAll,
    listStructure,
    noEntries: listStructure.totalItems === 0,
  }
}
